import { DatePipe } from "@angular/common";
import { Component, inject, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { SharedService } from "src/app/Shared/shared-service.service";
import { SheetDetails } from "src/model/assetSheetRequestDetails.model";
import { Company } from "src/model/company.model";
import { AssetSheetRequestService } from "src/services/asset-sheet-request.service";
import { CompanyService } from "src/services/company.service";

@Component({
  selector: "app-asset-sheet-request-log",
  standalone: false,
  templateUrl: "./asset-sheet-request-log.component.html",
  styleUrl: "./asset-sheet-request-log.component.scss",
})
export class AssetSheetRequestLogComponent implements OnInit {
  protected activeModal = inject(NgbActiveModal);
  protected sheetRequestService = inject(AssetSheetRequestService);
  protected assetSheetRequestList: SheetDetails[] = new Array();
  protected companyService = inject(CompanyService);
  protected sharedService = inject(SharedService);
  protected datepipe = inject(DatePipe);

  protected requestedAfter: Date;
  protected requestedBefore: Date;
  protected companyId: number;
  protected companyList: Company[] = new Array();
  async ngOnInit() {
    if (this.sharedService.isMonitoringUser()) {
      this.companyList = await this.companyService.getAllCompanies();

      this.companyList.sort((a, b) => {
        return a.CompanyCode > b.CompanyCode ? 1 : -1;
      });
    }

    const today = new Date();
    this.requestedAfter = today;
    this.requestedBefore = today;

    this.getListBasedOnCondition();
  }

  async getListBasedOnCondition() {
    //set before after date, start date always start from earliest time, end date always end with latest time
    let requestedAfter = new Date(this.requestedAfter.setHours(0, 0, 0));
    let requestedBefore = new Date(
      this.requestedBefore.setHours(23, 59, 59, 59),
    );

    this.assetSheetRequestList =
      await this.sheetRequestService.getAllAssetSheetRequests({
        companyId: this.companyId,
        requestedAfter: requestedAfter,
        requestedBefore: requestedBefore,
      });
  }

  submit() {
    this.getListBasedOnCondition();
  }
  reset() {
    this.activeModal.close();
  }
}
